import colors from "theme/config/colors";

export const baseStyle = `
    html {
        height: 100%;
        font-family: myriad-pro, sans-serif;
        color: ${colors.black};
    }
    body {
        min-height: 100%;
        padding: 0;
        margin: 0;
        font-size: 16px;
        line-height: 1em;
        font-weight: 300;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        overflow-x: hidden;

        &.prevent-scroll {
            overflow: hidden;

            @supports (-webkit-overflow-scrolling: touch) {
                position: fixed;
                width: 100%;
            }
        }
    }

    #root {
        height: 100%;
    }
`;
